import React, { useCallback, useState } from 'react';
import { Button } from '@gafe/common-ui';

import { ButtonWidget, SnapActionProps } from '@/components/generic/SnapButton/types';

import style from './SnapButton.module.scss';

export const SnapAction = ({ space, projectKey, text, icon }: SnapActionProps) => {
  const [error, setError] = useState<boolean>(false);

  const onClick = useCallback(() => {
    space
      .show(projectKey)
      .then(w => {
        const widget = w as ButtonWidget;

        return widget.open({});
      })
      .catch(() => setError(true));
  }, []);

  if (error) return null;

  return (
    <Button
      className={style.snap_action_button}
      onClick={onClick}
      prependIcon={icon}
      variant="text"
    >
      {text}
    </Button>
  );
};
